// extracted by mini-css-extract-plugin
module.exports = {"root":"FindAllAnswers-module--root--HEYbG","bg":"FindAllAnswers-module--bg--3gb_g","screen":"FindAllAnswers-module--screen--2Ab_Q"};